// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","info":"Header_info__5whlc"};